module.exports = __webpack_public_path__ + "static/media/icon-left-chevron.8d7aab9a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/product-detail/image-carousel/icon-left-chevron.svg
// module id = 999
// module chunks = 1